import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from './storage.service';

/** Les six langues de l'app, dans l'ordre des listes existantes. */
export const APP_LANGUAGES = ['FR', 'NL', 'EN', 'DE', 'IT', 'ES'] as const;

/**
 * Le nom de chaque langue dans cette langue même (« Nederlands », pas
 * « néerlandais »). Ce ne sont pas des traductions : on retrouve la sienne
 * même dans une app réglée sur une langue qu'on ne lit pas.
 */
export const LANGUAGE_NATIVE_NAMES: Record<string, string> = {
  FR: 'Français',
  NL: 'Nederlands',
  EN: 'English',
  DE: 'Deutsch',
  IT: 'Italiano',
  ES: 'Español',
};

/**
 * Bascule l'app dans une langue, tout de suite.
 *
 * Le choix est mémorisé en MAJUSCULES (c'est ce que lit le reste de l'app) mais
 * `ngx-translate` attend des minuscules : se tromper de casse laisse l'app dans
 * l'ancienne langue sans erreur visible.
 */
@Injectable({ providedIn: 'root' })
export class AppLanguageService {
  private readonly storage = inject(StorageService);
  private readonly translate = inject(TranslateService);

  apply(language: string): void {
    this.storage.setCurrentLang(language.toUpperCase());
    this.translate.use(language.toLowerCase());
  }
}
